import { observe } from 'mobx';

export type MuiLightDarkType = 'light' | 'dark';
export type LightDarkType = MuiLightDarkType | 'system';

export function getDarkLightMode(): MuiLightDarkType {
	const userSetting = window.localStorage.getItem('dark-theme');

	if (userSetting === 'false') {
		return 'light';
	} else if (userSetting === 'true') {
		return 'dark';
	}

	return getSystemSetting() ? 'dark' : 'light';
}

export function getMaeLightDarkMode(): LightDarkType {
	const userSetting = window.localStorage.getItem('dark-theme');

	if (userSetting === 'false') {
		return 'light';
	} else if (userSetting === 'true') {
		return 'dark';
	}

	return 'system';
}

export function getSystemSetting(): MuiLightDarkType {
	const defaultSetting = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
	return defaultSetting ? 'dark' : 'light';
}

export { observe as maeObserve };
